import $ from 'jquery'

// eslint-disable-next-line no-undef
const object = vnObject

const initializeBlock = function ($block) {
  let block = $block.find('.faq-block')
  if (!block.length) {
    block = $block
  }

  const container = block.find('.faq-posts')

  block.find('.faq-filter').on('click', function () {
    const id = $(this).attr('data-id') * 1

    $.ajax({
      url: object.ajaxUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        _ajax_nonce: object.nonce,
        action: 'vn_get_faq_posts',
        id,
      },
      beforeSend: () => {
        block.addClass('loading').append(object.loader)
        block.find('.faq-filter').prop('disabled', true)
      },
      success: (res) => {
        if (res.success) {
          container.html(res.data.content).show()
          block.find('.faq-filter').removeClass('active')
          $(this).addClass('active')
        }
      },
      complete: () => {
        block.find('.vn-loader').remove()
        block.removeClass('loading')
        block.find('.faq-filter').prop('disabled', false)
      },
    })
  })

  block.on('click', '.feed-faq__title', function () {
    $(this).parent().parent().toggleClass('active')
    $(this).parent().find('.feed-faq__content').slideToggle()
  })
}

$('.faq-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=smat-faq', initializeBlock)
}
